import { useFormik } from "formik";
import React from "react";
import PropTypes from "prop-types";
import * as yup from "yup";
import classes from "./AnswerText.module.scss";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { squashSpaces } from "../../../../../../utilities/general";
import { TextAutocomplete } from "../../../../shared/TextAutocomplete/TextAutocomplete";

export function AnswerText({
  isRequired,
  initialValues,
  onSubmit,
  renderFooter,
  useAutocomplete,
}) {
  const { tCommon } = useAppTranslation.Common();

  const validationSchema = yup.object({
    text: yup.lazy(() => {
      const schema = yup.string().trim();
      if (isRequired) {
        return schema.required();
      }
      return schema;
    }),
  });

  const { values, handleChange, handleSubmit, errors, touched } = useFormik({
    validationSchema,
    onSubmit,
    enableReinitialize: true,
    initialValues: {
      text: squashSpaces(initialValues.text) || "",
    },
  });

  const isError = errors.text && touched.text;

  const onFinishLater = () => {
    onSubmit(values, { saveForLater: true });
  };

  return (
    <div className={classes.root}>
      <TextAutocomplete
        name="text"
        value={values.text}
        onChange={handleChange}
        placeholder={tCommon("fillPatientQuestionnaire.textAnswerPlaceholder")}
        useAutocomplete={useAutocomplete}
      />
      {renderFooter(handleSubmit, isError, onFinishLater)}
    </div>
  );
}

AnswerText.propTypes = {
  isRequired: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    text: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  renderFooter: PropTypes.func.isRequired,
  useAutocomplete: PropTypes.bool,
};
